import { findElementById, getParentElementId } from './editor';
import { IElement } from '@routes/private/Editor/types';

export const isElementHidden = (elementId: string, data: IElement[]): boolean|undefined => {
    const element = findElementById(data, elementId);
    if(!element) return undefined;
    else return element.attributes.hidden;
}

export const isElementOrParentHidden = (elementId: string, data: IElement[]): boolean|undefined => {
    const element = findElementById(data, elementId);
    if(!element) return undefined;
    else {
        if (element.attributes.hidden) {
            return true;
        }
        else {
            const parentId = getParentElementId(elementId, data);
            if (!parentId) return false;
            else return isElementOrParentHidden(parentId, data);
        }
    } 
}

export const isElementOrParentHiddenInOtherThanMultiEditing = (elementId: string, data: IElement[]): boolean|undefined => {
    const element = findElementById(data, elementId);
    if(!element) return undefined;
    else {
        if (element.attributes.hidden && element.attributes.hiddenChangeOrigin !== 'MULTIEDITOR_PICKER') {
            return true;
        }
        else {
            const parentId = getParentElementId(elementId, data);
            if (!parentId) return false;
            else return isElementOrParentHiddenInOtherThanMultiEditing(parentId, data);
        }
    } 
}